import { useQuery } from 'react-query';
import request from '../helpers/request';
import { queryKeys } from './queryKeys';

const getRequestAttachments = async (requestId) => {
  return await request.get(
    `/Request/request_attachments/${requestId}`,
    {},
    'Не удалось загрузить вложения для заявки',
    []
  );
};

const useRequestAttachments = (requestId, options) =>
  useQuery(
    queryKeys.requestAttachments(requestId),
    () => getRequestAttachments(requestId),
    {
      enabled: !!requestId,
      ...options,
    }
  );

export default useRequestAttachments;
